import React from 'react';
import { ModalProps } from '@/Types';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { EmailPreviewModal } from './modules/EmailPreviewModal/EmailPreviewModal';
import { emailSendModalActions, SendEmailStep } from './services/reducer';
import { SelectDocumentModal } from './modules/SelectDocumentModal/SelectDocumentModal';
import { CreateDocumentModal } from './modules/CreateDocumentModal/CreateDocumentModal';
import { SelectTemplateModal } from './modules/SelectTemplateModal/SelectTemplateModal';
import { SingleDocumentSendModal } from './modules/SingleDocumentSendModal/SingleDocumentSendModal';
import { useEmailSendModalOptions } from './hooks/useEmailSendModalOptions';
import { TemplateNotExists } from './modules/TemplateNotExistsModal/TemplateNotExistsModal';

export const EmailSendModal = ({ closeModalWindow }: ModalProps): React.ReactElement | null => {
  const dispatch: AppDispatch = useDispatch();

  const { currentStep } = useEmailSendModalOptions();

  const onCloseModal = () => {
    dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.Close));
  };

  switch (currentStep) {
    case SendEmailStep.TemplateNotExists:
      return <TemplateNotExists onClose={onCloseModal} />;

    case SendEmailStep.SingleDocumentPrint:
      return <SingleDocumentSendModal onClose={onCloseModal} />;

    case SendEmailStep.SelectTemplate:
      return <SelectTemplateModal onClose={onCloseModal} />;

    case SendEmailStep.CreateDocument:
      return <CreateDocumentModal onClose={onCloseModal} />;

    case SendEmailStep.SelectDocumentNumber:
      return <SelectDocumentModal onClose={onCloseModal} />;

    case SendEmailStep.EmailPreview:
      return <EmailPreviewModal onClose={onCloseModal} />;

    case SendEmailStep.None:
      return null;

    case SendEmailStep.Close:
    default:
      closeModalWindow();
      return null;
  }
};
